import React from "react";
import { convertStringUndefined } from "../../../components/navigation/SearchString.tsx";
import {
  type AssetRegisterItem,
  useGetAssetRegisterListAssetRegisterGet,
} from "../../../kubb";
import AssetListFilterForm, {
  type AssetListFilterParams,
} from "../assets/list/AssetListFilterForm.tsx";
import AssetRegisterSelectComponent from "./AssetRegisterSelectComponent.tsx";

interface AssetRegisterSelectWrapperProps {
  initialValues: AssetListFilterParams;
  setValues: (values: AssetRegisterItem[]) => void;
  lastUpdateDate?: Date;
}

export default function AssetRegisterSelectWrapper(
  props: AssetRegisterSelectWrapperProps,
): React.ReactElement {
  const [params, setParams] = React.useState<AssetListFilterParams>(
    props.initialValues,
  );
  const query = useGetAssetRegisterListAssetRegisterGet(
    convertStringUndefined(params),
    {
      query: {
        refetchInterval: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false,
        refetchOnReconnect: false,
      },
    },
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: we want to trigger when lastUpdateDate changes
  React.useEffect(() => {
    query.refetch();
  }, [props.lastUpdateDate, query.refetch]);

  return (
    <>
      <AssetListFilterForm
        includeNonCreateables={false}
        filterUnassignedField={"asset_id"}
        includeTextSearch={true}
        includeStatus={false}
        includeIssueStatus={false}
        includeRetiredFilter={false}
        params={params}
        onSubmit={(v) => {
          setParams(v);
          props.setValues([]);
        }}
        dense={true}
        includeSchemeFilter={true}
      />
      <div className={"pt-1 h-[300px]"}>
        <AssetRegisterSelectComponent
          loading={query.isLoading || query.isRefetching}
          items={query.data?.data || []}
          setValues={props.setValues}
        />
      </div>
    </>
  );
}
